import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=0d8f8909&"
import script from "./inbox.vue?vue&type=script&lang=ts&"
export * from "./inbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports